<template>
	<div>
        <div class="theme-loader">
            <div class="ball-scale">
                <div class='contain'>
                    <img src="../assets/loader.gif">
                </div>
            </div>
        </div>
        <div id="pcoded" class="pcoded">
            <div class="pcoded-overlay-box"></div>
            <div class="pcoded-container navbar-wrapper">

                <navbar1 />

                <div class="pcoded-main-container">
                    <div class="pcoded-wrapper">
                        
                        <navbar2 />

                        <div class="pcoded-content">
                            <div class="pcoded-inner-content">
                                <div class="main-body">
                                    <div class="page-wrapper" style="background: #fff;">
                                        <div class="page-body">
                                            <h4></h4>
                                            <div class="card card-current-prog">
                                                <div class="card-header">
                                                    <div class="card-header-left">
                                                        <h5>Shared Resumes</h5>
                                                    </div>
                                                    <div class="card-header-right">
                                                        <ul class="list-unstyled card-option">
                                                            <li><i class="icofont icofont-simple-left "></i></li>
                                                            <li><i class="icofont icofont-maximize full-card"></i></li>
                                                            <li><i class="icofont icofont-minus minimize-card"></i></li>
                                                            <li><i class="icofont icofont-refresh reload-card"></i></li>
                                                            <li><i class="icofont icofont-error close-card"></i></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div class="card-block">
                                                    <div class="table-responsive">
                                                        <table class="table">
                                                            <tbody>
                                                                <tr v-for="applicant in resumes">
                                                                    <td>
                                                                        <div class="card-img">
                                                                            <a v-bind:href="'/opening/' + applicant.joblisting_id + '/application/' + applicant.id"><img class="img-rounded" src="../assets/img/user-icon.jpg" alt=""></a>
                                                                        </div>
                                                                        <div class="card-contain">
                                                                            <a v-bind:href="'/opening/' + applicant.joblisting_id + '/application/' + applicant.id" class="f-w-600">{{applicant.firstname + " " + applicant.lastname}}</a>
                                                                            <br>
                                                                            <p class="text-muted">{{applicant.emailaddress}}</p>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div class="last-line">
                                                                            <p class="">Submitted on {{applicant.created_at.split(" ")[0]}}</p>
                                                                        </div>
                                                                        <div class="card-icon-time">
                                                                            <i class="icofont icofont-ui-clock text-muted"></i>
                                                                            <p class="text-muted">{{applicant.created_at.split(" ")[1]}}</p>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import navbar1 from '../components/Navbar1.vue'
import navbar2 from '../components/Navbar2.vue'

export default {
    name: 'AddOpening',

    data(){
        return{
            resumes: []
        }
    },

    components:{
        navbar1,
        navbar2
    },

    mounted(){
        this.getSharedResumes()
    },
    methods: {

        getSharedResumes: function(){

            let resumes = {
                what: 'GetSharedResumes'
            }

            this.$socket.makeGetRequest(resumes)
                .then((response)=>{
                    if(response.type == "GetSharedResumes"){
                        this.resumes = response.data
                    }
                })
                .catch((error)=>{
                    console.log(error)
                })
        }
    },
    computed: {
        
    }
}
</script>
